export default {
    getBookingForm: (state) => {
        return state.bookingForm
    },
    getBooking: (state) => {
        return state.booking
    },
    getBookingChangelog: (state) => {
        return state.bookingChangelog
    },
    getIsReturnBooking: (state) => {
        return state.isReturnBooking
    },
    isUnConfirmedUpdate: (state) => {
        return state.isUnConfirmedUpdate
    },
    isOfferPublicly: (state) => {
        return state.offerPublicly
    }
}
